import intl from "react-intl-universal";

import {IDataClientService} from "../../platform/services/data/DataClientService";
import {IAuthService} from "../../platform/services/auth/AuthService";
import {snackBarRef} from "../../stores/snackbarRef";
import {AuditTemplateGqlProvider} from "../../stores/audit/AuditTemplateGqlProvider";

export const deleteAudit = async (
    dataClientService: IDataClientService,
    authService: IAuthService,
    wsId: string,
    id: string,
): Promise<void> => {
    const provider = new AuditTemplateGqlProvider({dataClientService, authService}, wsId);
    await provider.delete(id);
    snackBarRef.current?.enqueueSnackbar({
        message: intl.get('audits.delete.success').d('Audit deleted'),
    });
};
